export interface Offer {
  offer_id: string;
  title: string;
  description: string;
  label: string;
  code: string;
  featured: string; // "Yes" | "No"
  source: string;
  deeplink: string;
  affiliate_link: string;
  cashback_link: string;
  url: string;
  image_url: string;
  brand_logo: string;
  type: string; // e.g. "Deal" | "Coupon"
  store: string; // domain
  merchant_home_page: string;
  merchant_name?: string;
  categories: string;
  standard_categories: string;
  start_date: string | null;
  end_date: string | null;
  status: string; // e.g. "new"
  primary_location: string;
  locations: string;
  language: string;
  rating: string;
}

export interface IncrementalFeedResponse {
  result: boolean;
  offers: Offer[];
}

export const getCouponAPI = async (): Promise<IncrementalFeedResponse> => {
  try {
    const res = await fetch(
      "https://coupon-data-750219299255.asia-northeast1.run.app/coupon?action=data"
    );

    if (!res.ok) {
      throw new Error(`Request failed: ${res.status} ${res.statusText}`);
    }

    const offers = (await res.json()) as Offer[];

    if (!Array.isArray(offers)) {
      throw new Error("Unexpected data format: expected an array");
    }

    return { result: true, offers };
  } catch (error) {
    console.error("Failed to fetch data from coupon API:", error);
    return { result: false, offers: [] };
  }
};
